export const WAITLIST_AUDIENCE_ROLES = [
  'parent_guardian',
  'student_primary',
  'student_secondary',
  'student_university',
  'teacher_tutor',
  'company_organization',
  'other'
] as const

export type WaitlistAudienceRole = (typeof WAITLIST_AUDIENCE_ROLES)[number]

/**
 * Display labels for the audience roles — single source for the signup dialog's
 * listbox options and for both waitlist e-mails. Marketing copy: safe to reword.
 * The values CRM persists live in `crm/system-event-types.ts` and are
 * deliberately decoupled from these, so a copy tweak cannot fork the CRM
 * taxonomy or orphan labels already stored in historical events.
 */
export const WAITLIST_AUDIENCE_ROLE_LABELS_PL = {
  parent_guardian: 'Rodzic / opiekun prawny',
  student_primary: 'Uczeń / uczennica — szkoła podstawowa',
  student_secondary: 'Uczeń / uczennica — szkoła średnia',
  student_university: 'Student / studentka',
  teacher_tutor: 'Nauczyciel / korepetytor',
  company_organization: 'Firma / organizacja',
  other: 'Inna kategoria'
} as const satisfies Record<WaitlistAudienceRole, string>

export type WaitlistAudienceRoleLabel =
  (typeof WAITLIST_AUDIENCE_ROLE_LABELS_PL)[WaitlistAudienceRole]
